// extracted by mini-css-extract-plugin
export default {"PageWrapper":"kEnE4oenLTI1mWiDJ9pdMg== TiMDJXlqnUWiHID31gGyCg==","PageWrapperBreadcrumbs":"sHiyxe4e-WMGq7TRTDDU2g== -E-Ps9MCnNw4QdFsFq8fqA=="};